module.exports = {"title":"사용자 관리","resetPassword":"비밀번호 재설정","id":"아이디","name":"이름","phone":"휴대폰","email":"이메일","status":"상태","role":"권한","assignedGolfClub":"담당 골프클럽","notificationSettings":"알림설정","notification":"알림","optOut":"수신거부","optIn":"수신허용","sms":"문자(SMS)","lastUpdated":"최근 업데이트","editButton":"수정하기","newPassword":"신규 비밀번호","confirmNewPassword":"신규 비밀번호 확인","statusActive":"활성화","statusInactive":"비활성화","roleAplManager":"APL관리자","roleAplMaster":"APL마스터","roleSktDeveloper":"SKT개발자","roleAplDeveloper":"APL개발자","roleClubManager":"클럽관리자","passwordResetDone":"비밀번호가 재설정되었습니다."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/ma002.json
// module id = 2rTV
// module chunks = 2